export const ACTOR_CATEGORIES = [
  {"name": "Civilians", "colour": "var(--color-civilians)"},
  {"name": "External/Other forces", "colour": "var(--color-external-forces)"},
  {"name": "Identity militia", "colour": "var(--color-identity-militia)"},
  {"name": "Political militia", "colour": "var(--color-political-militia)"},
  {"name": "Protesters", "colour": "var(--color-protesters)"},
  {"name": "Rebel group", "colour": "var(--color-rebel-group)"},
  {"name": "Rioters", "colour": "var(--color-rioters)"},
  {"name": "State forces", "colour": "var(--color-state-forces)"}
];
